import ConfirmMail from '../components/ConfirmMail/index';

const ConfirmMailView = () => {
    return <ConfirmMail />;
};

export default ConfirmMailView;
